var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMusicAlbum(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "music album") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "nc-icon-wrapper",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    fill: "#de6139",
    stroke: "#de6139"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 3,
    width: 16,
    height: 18,
    fill: "none",
    stroke: "#de6139",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    "data-color": "color-2",
    x1: 1,
    y1: 6,
    x2: 1,
    y2: 18,
    fill: "none",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    "data-color": "color-2",
    x1: 23,
    y1: 6,
    x2: 23,
    y2: 18,
    fill: "none",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("polyline", {
    "data-cap": "butt",
    points: "10 15 10 8 16 8 16 14",
    fill: "none",
    stroke: "#de6139",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    "data-stroke": "none",
    cx: 9,
    cy: 15,
    r: 2,
    fill: "#de6139",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-stroke": "none",
    cx: 15,
    cy: 14,
    r: 2,
    fill: "#de6139",
    stroke: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicAlbum);
export default __webpack_public_path__ + "static/media/music-album.025bb423.svg";
export { ForwardRef as ReactComponent };